"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  headlineLarge: {
    element: 'h1',
    fontFamily: '"PublicSans", "Verdana", sans-serif',
    fontSize: '32px',
    lineHeight: '40px',
    fontWeight: '400',
    letterSpacing: '-0.19px'
  },
  headlineMedium: {
    element: 'h2',
    fontFamily: '"PublicSans", "Verdana", sans-serif',
    fontSize: '28px',
    lineHeight: '36px',
    fontWeight: '375',
    letterSpacing: '-0.08px'
  },
  headlineSmall: {
    element: 'h3',
    fontFamily: '"PublicSans", "Verdana", sans-serif',
    fontSize: '24px',
    lineHeight: '32px',
    fontWeight: '400',
    letterSpacing: '0.02px'
  },
  titleLarge: {
    element: 'h4',
    fontFamily: '"PublicSans", "Verdana", sans-serif',
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: '500',
    letterSpacing: '0.11px'
  },
  titleMedium: {
    element: 'h5',
    fontFamily: '"PublicSans", "Verdana", sans-serif',
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: '530',
    letterSpacing: '0.08px',
    fontFeatureSettings: "'tnum' on, 'lnum' on"
  },
  titleSmall: {
    element: 'h6',
    fontFamily: '"PublicSans", "Verdana", sans-serif',
    fontSize: '11px',
    lineHeight: '16px',
    fontWeight: '500',
    letterSpacing: '1.6px',
    textTransform: 'uppercase',
    fontFeatureSettings: "'tnum' on, 'lnum' on, 'liga' off"
  },
  bodyMediumInterface: {
    element: 'p',
    fontFamily: '"PublicSans", "Verdana", sans-serif',
    fontSize: '14px',
    lineHeight: '16px',
    fontWeight: '380',
    letterSpacing: '0.15px',
    fontFeatureSettings: "'tnum' on, 'lnum' on"
  },
  bodyMediumParagraph: {
    element: 'p',
    fontFamily: '"PublicSans", "Verdana", sans-serif',
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: '380',
    letterSpacing: '0.15px',
    fontFeatureSettings: "'tnum' on, 'lnum' on"
  },
  bodyLargeInterface: {
    element: 'p',
    fontFamily: '"PublicSans", "Verdana", sans-serif',
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: '400',
    letterSpacing: '0.05px',
    fontFeatureSettings: "'tnum' on, 'lnum' on"
  },
  bodyLargeParagraph: {
    element: 'p',
    fontFamily: '"PublicSans", "Verdana", sans-serif',
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: '400',
    letterSpacing: '0.05px',
    fontFeatureSettings: "'tnum' on, 'lnum' on"
  },
  button: {
    element: 'span',
    fontFamily: '"PublicSans", "Verdana", sans-serif',
    fontSize: '11px',
    lineHeight: '16px',
    fontWeight: '650',
    letterSpacing: '0.97px',
    textTransform: 'uppercase',
    fontFeatureSettings: "'tnum' on, 'lnum' on, 'liga' off"
  },
  caption: {
    element: 'span',
    fontFamily: '"PublicSans", "Verdana", sans-serif',
    fontSize: '11px',
    lineHeight: '16px',
    fontWeight: '500',
    letterSpacing: '0.18px',
    fontFeatureSettings: "'tnum' on, 'lnum' on"
  },
  bodyShort: {
    element: 'p',
    fontFamily: '"PublicSans", "Verdana", sans-serif',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '16px',
    letterSpacing: '0.1px'
  },
  bodyLong: {
    element: 'p',
    fontFamily: '"PublicSans", "Verdana", sans-serif',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '20px',
    letterSpacing: '0.1px'
  },
  tooltipLabel: {
    element: 'span',
    fontFamily: '"PublicSans", "Verdana", sans-serif',
    fontSize: '11px',
    fontWeight: '500',
    lineHeight: '12px',
    letterSpacing: '0.05px'
  },
  chartLabel: {
    element: 'span',
    fontFamily: '"PublicSans", "Verdana", sans-serif',
    fontSize: '11px',
    fontWeight: '500',
    lineHeight: '12px',
    letterSpacing: '0.05px'
  }
};